import { useDrop } from 'react-dnd'
import styles from './Card.module.scss'
import ImageDropCursor from 'src/assets/icons/drop_cursor.svg?react'


type Props = {
  accept: string
  source: string
  onDrop: (item: any) => void
  isAusCourse?: boolean
  isNewMovable?: boolean
}

function DropBox(props: Props) {
    const { accept, source, isAusCourse, isNewMovable, onDrop } = props

    const [{ isOver, canDrop }, drop] = useDrop({
        accept,
        drop: onDrop,
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    })

    const isActive = isOver && canDrop
    let dropCardStyle = styles.dropAdditionCard
    let label = "Drag and Drop Units"
    switch (source) {
        case 'grade':
            if (isAusCourse) {
                dropCardStyle = styles.dropContentCard
            } else {
                dropCardStyle = styles.dropGradeCard
            }
            
            break
        case 'addition':
            dropCardStyle = styles.dropAdditionCard
            break
        case 'origin':
            dropCardStyle = styles.dropUnitsCard
            label = "Drag and Drop Units here to remove"
            break
        default:
            break
    }
    if (isActive) {
        if (isAusCourse) {
            if (isNewMovable) {
                dropCardStyle = styles.dropContentCard
            } else {
                dropCardStyle = styles.dropSmallContentCard
            }
        } else {
            dropCardStyle = styles.dropGradeCard
        }
    } else if (canDrop) {
        if (isAusCourse) {
            if (isNewMovable) {
                dropCardStyle = styles.dropContentCard
            } else {
                dropCardStyle = styles.dropSmallContentCard
            }
        } else {
            dropCardStyle = styles.dropUnitsCard
        }
    }

    return (
        <div ref={drop} className={`${dropCardStyle} ${canDrop ? styles.canDropbackground : ''}`}>
            <div>
                <ImageDropCursor className={styles.dropImage}/>
                <p className={styles.labelPadding}>{label}</p>
            </div>
        </div>
    )
}

export default DropBox
